import { DEBT_RECEIPT_CREATE_PAGE } from "routes/route.constant";
import DebtReceipt from "./DebtReceipt";

const route = {
  path: DEBT_RECEIPT_CREATE_PAGE,
  element: DebtReceipt,
};

export default route;
